import { AliasPills } from './alias-pills';
import styles from './alias-option.module.scss';
import { aliasPillsFromNames } from './utils';

export interface AliasOptionProps {
  label: string;
  /** The record's alias names, as a search result row carries them. */
  aliases?: readonly string[] | null;
}

/**
 * A picker option: the record's name, and under it its aliases as read-only pills. Without aliases it is
 * the name alone, so an option looks as it did before tags existed.
 * @param {AliasOptionProps} props - The option's name and the record's aliases.
 * @return {JSX.Element} The option's content.
 */
export function AliasOption({ label, aliases }: AliasOptionProps) {
  return (
    <span className={styles.option}>
      <span className={styles.label}>{label}</span>
      <AliasPills aliases={aliasPillsFromNames(aliases)} />
    </span>
  );
}
